// PERF: Extracted from theme.liquid to reduce inline script size
// LoyaltyLion Landing Page – Rewards Products
// Only loads on rewards page
;(function () {
  'use strict'

  function isRewardsPage() {
    return location.pathname.replace(/\/+$/, '') === '/pages/rewards'
  }

  // Small delay helper
  const sleep = ms => new Promise(r => setTimeout(r, ms))

  // Wait for LoyaltyLion to expose its token so we don't race the SDK
  async function waitForLLToken(timeoutMs = 12000, intervalMs = 150) {
    const start = Date.now()
    while (!window.loyaltylion?.token) {
      if (Date.now() - start > timeoutMs) return null
      await sleep(intervalMs)
    }
    return window.loyaltylion.token
  }

  // Fetch with retry/backoff
  async function fetchJSONWithRetry(url, opts = {}, tries = 3) {
    let lastErr
    for (let i = 0; i < tries; i++) {
      try {
        const res = await fetch(url, opts)
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        return await res.json()
      } catch (e) {
        lastErr = e
        await sleep(300 * (i + 1))
      }
    }
    console.error('[ERROR] Rewards fetch failed after retries:', lastErr)
    return null
  }

  // Pull product-type rewards from LoyaltyLion, keeping the product handle & art
  async function fetchProductCartRewards() {
    const token = await waitForLLToken()
    if (!token) {
      console.warn('[WARN] LoyaltyLion token did not appear in time.')
      return []
    }

    // Cache-bust with Date.now()
    const url = `https://sdk.loyaltylion.net/sdk/2023-11/config/${token}?t=${Date.now()}`

    const data = await fetchJSONWithRetry(url, { method: 'GET', mode: 'cors', credentials: 'omit' }, 3)
    if (!data) return []

    const rewards = data.program?.rewards || []

    // Keep only rewards that target at least one product
    const productRewards = rewards.filter(
      r =>
        (r.kind === 'product_cart' || r.kind === 'product') &&
        Array.isArray(r.target_products) &&
        r.target_products.length > 0
    )

    // Normalize the minimal fields we need for rendering + linking
    const normalized = productRewards
      .map(r => {
        const tp = r.target_products?.[0] || {}
        return {
          title: r.title,
          points: r.point_cost,
          // Prefer the reward content image, fall back to product image, then to a generic icon
          image:
            r.content?.featured_image_url ||
            tp.image_url ||
            'https://sdk-static.loyaltylion.net/static/2/themes/modern/86f7643/img/icons/rewards/free-product.svg',
          handle: tp.handle, // <<— use handle directly from LL
          productId: tp.id // optional (kept for debugging/analytics)
        }
      })
      .filter(n => !!n.handle) // ensure we have a handle

    return normalized
  }

  function renderRewardsToContainer(rewards) {
    const checkInterval = setInterval(() => {
      const container = document.getElementById('freeproductscustom')
      if (!container) return

      clearInterval(checkInterval)

      if (!rewards.length) {
        container.innerHTML = '<p>No free product rewards found.</p>'
        return
      }

      const cardsHtml = rewards
        .map(r => {
          return `
          <div class="reward-card" data-handle="${r.handle}">
            <img src="${r.image}" alt="${r.title}" style="width:100%;" />
            <p style="margin-top:10px;margin-bottom:5px;font-weight:bold;font-size:14px;">${r.title}</p>
            <p style="color:#777;font-size:14px;margin-top:0;margin-bottom:5px;" class="reward-points">
              ${Number(r.points || 0).toLocaleString()} points
            </p>
          </div>
        `
        })
        .join('')

      container.innerHTML = `
        <div style="width:100%;text-align:center;">
          <h3 class="reward-heading">Points for products</h3>
        </div>
        <div class="reward-card-wrapper">
          ${cardsHtml}
        </div>
      `

      // Link directly via handle — no Storefront API needed
      container.querySelectorAll('.reward-card').forEach(card => {
        const handle = card.getAttribute('data-handle')
        card.addEventListener('click', () => {
          if (handle) window.location.href = `/products/${handle}`
        })
      })

      // Handle anchor navigation after dynamic content is rendered
      if (window.location.hash === '#freeproductscustom') {
        setTimeout(() => {
          const target = document.getElementById('freeproductscustom')
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }, 100)
      }
    }, 100)
  }

  window.addEventListener('DOMContentLoaded', async () => {
    if (!isRewardsPage()) return
    const rewards = await fetchProductCartRewards()
    renderRewardsToContainer(rewards)
  })
})()
